<template>
  <div class="coumunities-dialog" v-if="show" v-show="nativeShow">
    <div class="dialog_content">
      <h4 class="dialog_content_title">社群公约</h4>
      <div class="dialog_content_main">
        <h6 class="main_title--minor">一、训练营社群规则</h6>
        <p class="main_text--minor text_indent--2">
          为了给用户营造一个积极向上、健康、高效、温暖的社群氛围，您在广州酷思纬哲网络科技公司（下称“我方”或“我们”）的互联网平台（包括有讲课堂APP、有讲课堂网站http://www.yojiang.cn、唯库公众号）所属的社群学习时须遵守如下训练营社群规则：
        </p>
        <p class="main_text--minor">（1）不得违反国家法律法规禁止性规定；</p>
        <p class="main_text--minor">（2）不得讨论政治性等敏感话题；</p>
        <p class="main_text--minor">
          （3）不得讨论封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的内容；
        </p>
        <p class="main_text--minor">（4）不得侮辱或者诽谤他人、侵害公民个人隐私等他人合法权益；</p>
        <p class="main_text--minor">
          （5）对影响社会稳定、破坏公共秩序的虚假消息，不转发，不扩散，并及时向社群内我方管理人员（以下称“班委”）反映；
        </p>
        <p class="main_text--minor">
          （6）未经班委允许，不得私自将我方平台学习资料（包括课程、加餐资料、答疑资料等）传播给他人；
        </p>
        <p class="main_text--minor">（7）未经班委允许，不得私加学习群内学员或邀请他人进群；</p>
        <p class="main_text--minor">
          （8）未经班委允许，不得私自进行引流行为，如推销任何平台或产品或发布与训练营无关的信息，包括广告、链接、小程序、外部群、二维码等，或私自对社群内成员进行建群、拉群等行为；
        </p>
        <p class="main_text--minor">
          （9）未与班委进行任何沟通，不得任意在群内发泄个人情绪，扰乱课堂秩序，影响其他学员；
        </p>
        <p class="main_text--minor">（10）其他影响课堂秩序、影响其他学员或我方正常运营管理的行为；</p>
        <p class="main_text--minor">（11）其他违反法律法规或损害社会公共利益的行为。</p>
        <p class="main_text--main text_indent--2">
          如您违反以上训练营社群规则，班委将有权将您暂时/永久移出训练营社群，情节严重者，我方有权立即终止向您提供课程服务，相关课程费用不予退还，并依法追究您的法律责任。
        </p>
        <h6 class="main_title--minor pad-top-20">二、知识产权说明 </h6>
        <p class="main_text--minor text_indent--2">我方内的所有内容（用户依法享有版权的内容除外）、技术、软件、程序、数据及其他信息（包括文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括版权、商标权、专利权、商业秘密等）及相关权利，均归我方或我方关联公司所有。未经我方许可，任何人不得擅自使用（包括复制、翻录、传播、展示、镜像、上载、下载、修改、出租）。</p>
        <p class="main_text--minor text_indent--2">我方的Logo等文字、图形及其组合，以及我方的其他标识、徵记、产品和服务名称均为我方或我方关联公司在中国或其它国家的商标，未经我方书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。</p>
        <p class="main_text--minor text_indent--2">我方对我方专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知识产权。未经我方许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯我方知识产权的行为，否则将承担所有相关的法律责任。</p>
        <p class="main_text--minor text_indent--2">如您侵犯我方知识产权，包括但不限于复制、翻录、传播我方的课程内容的，我方有权立即终止向您提供课程服务，不退还您已支付的课程费用，并要求您承担相应的侵权及赔偿责任。</p>
        <p class="main_text--minor text_indent--2">欢迎广大用户在发现上述情况时第一时间联系我们（客服邮箱：【hezhihao@yojiang.cn】），您的每一个微小动作，都会化为保护知识产权的一份力量。凡向我方提供有价值线索，协助我方取证者，我方将予以奖励并依法保护举报人的个人信息及隐私安全。</p>
        <p class="main_text--main text_indent--2">以上为有讲课堂训练营社群公约，希望广大用户自觉遵守，共同营造良好的学习环境。</p>
      </div>
      <div class="dialog_content_footer">
        <div class="dialog_footer_btn--common dialog_footer_btn--gray" @click="handlerNotAgree">不同意</div>
        <div class="dialog_footer_btn--common dialog_footer_btn--orange" @click="handlerAgree">同意</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { setProtocolInfo } from '@/api/protocol';
import router from '@/router';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const nativeShow = ref(true);

    const handlerNotAgree = () => {
      setProtocolInfo(props.courseId, 0).then(() => {
        nativeShow.value = false;

        router.replace(`/camp-learning/${props.courseId}`);
      });
    };

    const handlerAgree = () => {
      setProtocolInfo(props.courseId, 1).then(() => {
        nativeShow.value = false;
      });
    };

    return {
      nativeShow,
      handlerNotAgree,
      handlerAgree
    };
  },
};
</script>

<style lang="stylus" scoped>
.coumunities-dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);

  .dialog_content {
    margin-top: 120px;
    margin-bottom: 160px;
    padding: 16px 20px;
    width: 84vw;
    height: calc(100vh - 280px);
    background: #fff;
    border-radius: 8px;

    .dialog_content_title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 20px;
      height: 44px;
      font-size: 18px;
      font-weight: 500;
      color: #191919;
    }

    .dialog_content_main {
      overflow-y: auto;
      height: calc(100vh - 280px - 32px - 44px - 48px);

      .main_title--minor {
        display: flex;
        align-items: center;
        padding-bottom: 12px;
        font-size: 14px;
        font-weight: 500;
        color: #191919;
      }

      .main_text--minor {
        font-size: 14px;
        color: #999;
        line-height: 24px;
      }

      .main_text--main {
        margin-top: 20px;
        font-size: 14px;
        color: #191919;
        line-height: 24px;
      }
    }

    .dialog_content_footer {
      display: flex;
      justify-content: space-between;
      padding-top: 8px;
      height: 48px;

      .dialog_footer_btn--common {
        display: flex;
        align-items center
        justify-content center
        width: 35.73vw;
        height: 40px;
        border-radius: 22px;
        font-size 16px
        font-weight 500
      }

      .dialog_footer_btn--gray {
        color: #dadada;
        border: 1px solid #e7e7e7;
      }

      .dialog_footer_btn--orange {
        background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
        color: #fff;
      }
    }
  }
}

.pad-top-20 {
  padding-top: 20px;
}

.text_indent--2 {
  text-indent: 2em;
}
</style>
